import StandardTextBlock from "./content/StandardTextBlock";
import BulletListBlock from "./content/BulletListBlock";
import ComparisonBlock from "./content/ComparisonBlock";
import ConditionBlock from "./content/ConditionBlock";
import DefinitionListBlock from "./content/DefinitionListBlock";
import DrugClassBlock from "./content/DrugClassBlock";
import KeyValueBlock from "./content/KeyValueBlock";
import MuscleBlock from "./content/MuscleBlock";
import OutlineBlock from "./content/OutlineBlock";
import QABlock from "./content/QABlock";
import SequenceBlock from "./content/SequenceBlock";
import SymptomModificationBlock from "./content/SymptomModificationBlock";
import WorkedExampleBlock from "./content/WorkedExampleBlock";

export default function LearningContentBlock({ block }) {
  if (!block) return null;

  switch (block.block_type) {
    case "definition":
    case "paragraph":
      return (
        <StandardTextBlock
          block={block}
          variant="default"
        />
      );

    case "example":
      return (
        <StandardTextBlock
          block={block}
          variant="example"
        />
      );

    case "note":
      return (
        <StandardTextBlock
          block={block}
          variant="note"
        />
      );

    case "exam_note":
      return (
        <StandardTextBlock
          block={block}
          variant="exam_note"
        />
      );

    case "mnemonic":
      return (
        <StandardTextBlock
          block={block}
          variant="mnemonic"
        />
      );

    case "warning":
      return (
        <StandardTextBlock
          block={block}
          variant="warning"
        />
      );

    case "bullet_list":
      return <BulletListBlock block={block} />;

    case "comparison":
      return <ComparisonBlock block={block} />;

    case "condition":
      return <ConditionBlock block={block} />;

    case "definition_list":
      return <DefinitionListBlock block={block} />;

    case "drug_class":
      return <DrugClassBlock block={block} />;

    case "key_value":
      return <KeyValueBlock block={block} />;

    case "muscle":
      return <MuscleBlock block={block} />;

    case "outline":
      return <OutlineBlock block={block} />;

    case "qa":
      return <QABlock block={block} />;

    case "sequence":
      return <SequenceBlock block={block} />;

    case "symptom_modification":
      return (
        <SymptomModificationBlock block={block} />
      );

    case "worked_example":
      return <WorkedExampleBlock block={block} />;

    default:
      return (
        <div
          style={{
            padding: "18px",
            border: "1px solid #e5e7eb",
            borderRadius: "14px",
            marginBottom: "14px",
          }}
        >
          Unsupported learning block: {block.block_type}
        </div>
      );
  }
}